import GenericAreaPage from "@/components/GenericAreaPage";
import { getAreaContent } from "@/lib/area-content";

const Midtown = () => {
  const content = getAreaContent("midtown");
  if (!content) return null;
  return <GenericAreaPage content={content} />;
};

export default Midtown;